import { render, staticRenderFns } from "./DisableCaseCard.vue?vue&type=template&id=22b14b4a"
import script from "./DisableCaseCard.vue?vue&type=script&lang=js"
export * from "./DisableCaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports